import { Button } from "@sellar-io/components";
import { ReactElement } from "react";
import { useNavigate } from "react-router";
import {
  Dialog,
  DialogNavigation,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { CUSTOMERS } from "../../../../constants/routes";
import { useEvents } from "../../../../hooks";
import { useSupplierRelationshipDelete } from "../../../../hooks/api/v2/supplierRelationship/useSupplierRelationshipDelete";

export function ConnectionDeclineModal({
  connectionId,
  onDismiss,
  active,
}: {
  active: boolean;
  onDismiss: () => void;
  connectionId: number | string | undefined;
}): ReactElement | null {
  const navigate = useNavigate();
  const { track } = useEvents();

  const supplierRelationshipDeleteMutate = useSupplierRelationshipDelete(
    parseInt(connectionId?.toString() ?? ""),
  );

  const deleteConnection = () => {
    if (connectionId) {
      supplierRelationshipDeleteMutate.mutate(undefined, {
        onSuccess: () => {
          track("Connection Request Declined");
          navigate(CUSTOMERS);
        },
        onSettled: () => {
          onDismiss();
        },
      });
    }
  };
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        onClickLeftIcon={onDismiss}
        leftIcon={"CHEVRON_DOWN"}
        title={"Decline Connection"}
        description={
          "This will remove this request from your customer list. This cannot be undone."
        }
      />
      <DialogCTA>
        <Button
          loading={supplierRelationshipDeleteMutate.isPending}
          onClick={deleteConnection}
        >
          Decline
        </Button>
      </DialogCTA>
    </Dialog>
  );
}
